import { getGlobalHeadersAsObject } from "../global-headers";

export type SearchableLanguage = {
	language: string;
	proficiency: string;
	iso639_code: string | null;
	source: "declared" | "inferred";
	is_searchable: boolean;
};

export const getPersonSearchableLanguagesById = async (
	id: number
): Promise<SearchableLanguage[]> => {
	if (!id || typeof id !== "number") {
		throw new Error(
			`getPersonSearchableLanguagesById called with invalid argument id '${id}'. Expected number`
		);
	}

	const response = await fetch(`/api/v2/persons/${id}/searchable_languages/`, {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	});

	if (!response.ok) {
		throw new Error(`Failed to fetch searchable languages: ${response.status}`);
	}

	return response.json();
};
